// 平台管理员
import {getRoles} from '@/utils/cookie'
import {
  business,
  platform,
  platformUserPrefix,
  tenantUserPrefix
} from '@/api/common'

export const platformUser = 'platformUser'

// 租户
export const tenantUser = 'tenantUser'

/**
 * 根据角色获取服务名
 */
export const getBackendByRole = () => {
  return getRoles() === platformUser ? platform : business
}

/**
 * 根据角色获取Authorization
 */
export const getAuthorizationByRole = () => {
  return getRoles() === platformUser ? 'Basic cGxhdGZvcm06MTIzNDU2' : 'Basic dGVuYW50OjEyMzQ1Ng=='
}
/**
 * 根据角色获取url前缀
 * @returns {string}
 */
export const getUrlPrefixByRole = () => {
  let roles = getRoles()
  if (roles === platformUser) {
    return platformUserPrefix
  } else if (roles === tenantUser) {
    return tenantUserPrefix
  }
}



// WEBPACK FOOTER //
// ./src/utils/role/index.js